// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getStorage} from 'firebase/storage'; 
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

//import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
 apiKey: "AIzaSyAXQz6EACMvf9f2KPxVuQA9oC_vvjXN3kw",
  authDomain: "gemma-5f413.firebaseapp.com",
  projectId: "gemma-5f413",
  storageBucket: "gemma-5f413.appspot.com",
  messagingSenderId: "944095594703",
  appId: "1:944095594703:web:51cafab438d60f1c4dcfba"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig)

const storage = getStorage(app);
const db = getFirestore(app);
const auth = getAuth(app);

export {storage, db, auth}

//const analytics = getAnalytics(app);